#import "../fragments/lead-distribution-automation.graphql"

mutation UpdateLeadDistributionAutomation(
    $leadDistributionAutomation: UpdateLeadDistributionAutomationInputFieldInput!
) {
    updateLeadDistributionAutomation(
        input: {leadDistributionAutomation: $leadDistributionAutomation}
    ) {
        leadDistributionAutomation {
            ...LeadDistributionAutomation
        }
    }
}
